<template>
  <v-dialog
    scrollable
    v-model="isShowDialog"
    max-width="1000px"
    :persistent="true"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}
          <v-chip
            v-show="form.Status"
            :color="statusColor"
            small
          >{{ form.Status }}</v-chip>
        </span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text ref="cardContent">
        <v-form
          ref="form"
          v-model="isFormValid"
          :lazy-validation="true"
        >
          <v-container>
            <v-row>
              <v-col cols="12">
                <!-- 退回原因 -->
                <v-textarea
                  v-if="form.Status == '獎金退回'"
                  v-model="form.BonusRejectedReason"
                  label="獎金退回原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
                <v-textarea
                  v-if="form.Status == '主管退回'"
                  v-model="form.ReportRejectedReason"
                  label="日誌退回原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
                <v-textarea
                  v-if="form.Status == '被拒絕'"
                  v-model="form.WorkRejectedReason"
                  label="預排退回原因"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
                <v-textarea
                  v-if="form.Status == '主管重新確認'"
                  v-model="form.CheckBonusRejectedReason"
                  label="回報內容"
                  readonly
                  rows="1"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col cols="6" v-show="isViewProjectButtonShown">
                <v-autocomplete
                  :items="projects"
                  item-text="Name"
                  item-value="ID"
                  label="專案"
                  readonly
                  :value="project.ID"
                ></v-autocomplete>
                <a @click.prevent="redirectToProject(project.ID)" href="javascript:;">檢視專案</a>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  :items="tasks"
                  item-text="Name"
                  item-value="ID"
                  label="任務"
                  readonly
                  :value="form.TaskID"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  :items="userOptions"
                  item-text="Name"
                  item-value="ID"
                  label="執行人員"
                  readonly
                  v-model="form.UserID"
                ></v-autocomplete>
                <v-text-field
                  :value="formattedDate"
                  label="工作日期"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <!-- 工作內容 -->
                <v-textarea
                  v-model="form.Content"
                  readonly
                  rows="1"
                  auto-grow
                  label="工作內容"
                ></v-textarea>
                <!-- 執行狀況 -->
                <v-select
                  v-if="isWorkStatusVisible"
                  :items="workStatusOptions"
                  item-text="ID"
                  item-value="ID"
                  label="執行狀況"
                  v-model="form.WorkStatus"
                  :readonly="!isReportable&&!isManagerReportable"
                ></v-select>
                <!-- 處理說明 -->
                <v-textarea
                  v-if="isWorkReportVisible"
                  v-model="form.Report"
                  :readonly="!isReportable&&!isManagerReportable"
                  rows="1"
                  auto-grow
                  label="處理說明"
                ></v-textarea>
                <!-- <v-text-field
                  v-if="!isManagerReviewable && isMoneyVisible"
                  v-model="form.Budget"
                  label="獎金(預估)"
                  :readonly="!isDepartmentManagerVerifiable"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                ></v-text-field> -->

                <span v-if="budgetConsumptionTips != null">{{budgetConsumptionTips}} </span>
                <v-btn
                  v-else
                  class="ml-1 mr-1"
                  color="white"
                  text
                  small
                  @click.stop="viewBudgetConsumptionTips"
                >計算任務預算編列</v-btn>

                <v-text-field
                  v-if="(isDepartmentManagerReviewable||isManagerReviewable||isManagerReportable) && isMoneyVisible"
                  v-model="form.Bonus"
                  label="獎金(實發)"
                  :readonly="!isDepartmentManagerReviewable && !isManagerReportable"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                ></v-text-field>
                <v-chip
                  v-if="isDepartmentManagerReviewable"
                  v-show="isBonusOverBudget"
                  color="red"
                  small
                >
                  預算超標
                </v-chip>
              </v-col>
              <!-- <v-col cols="6">
                <v-text-field
                  v-model="form.EstimatedHours"
                  label="預估時數"
                  readonly
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                ></v-text-field>
              </v-col> -->
              <v-col cols="3">
                <!-- 處理時數 -->
                <v-text-field
                  v-if="isWorkActualHoursVisible"
                  v-model="form.ActualHours"
                  label="處理時數"
                  :readonly="!isReportable&&!isManagerReportable"
                  type="number"
                  step="1"
                  min="0"
                  max="1000000000"
                ></v-text-field>
              </v-col>
              <v-col cols="3">
                <!-- 分鐘 -->
                <v-text-field
                  v-if="isWorkActualHoursVisible"
                  v-model="form.ActualMinutes"
                  label="分鐘"
                  :readonly="!isReportable&&!isManagerReportable"
                  type="number"
                  step="1"
                  min="0"
                  max="59"
                  maxlength="2"
                  @input="onActualMinutesChanged"
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="shouldShowBudgetUseStatus">
                預算消耗狀況:
                <br>
                專案: {{project.Name}}
                <br>
                階段: {{task.ProjectStage}}
                <br>
                部門: {{taskDepartment.Name}}
                <br>
                總經理分配部門預算: ${{projectDepartmentBudget.Budget | amountFormat}}
                <br>
                此專案部門分配預算: 
                  <span v-if="totalAssignedBudgetsOfThisProject != null">${{totalAssignedBudgetsOfThisProject | amountFormat}} </span>
                  <v-btn
                    v-else
                    class="ml-1 mr-1"
                    color="white"
                    text
                    small
                    @click.stop="viewTotalAssignedBudgetsOfThisProject"
                  >計算</v-btn>
                <br>
                此專案部門審核預算:
                  <span v-if="totalReviewedBudgetsOfThisProject != null">${{totalReviewedBudgetsOfThisProject | amountFormat}} </span>
                  <v-btn
                    v-else
                    class="ml-1 mr-1"
                    color="white"
                    text
                    small
                    @click.stop="viewTotalReviewedBudgetsOfThisProject"
                  >計算</v-btn>

              </v-col>
              <v-col cols="12" v-if="shouldShowProjectWorkingDetail">
                <details>
                  <summary>任務分配細節</summary>
                  <task-working-item-table :task="task" :is-quick-sign-enabled="true"/>
                </details>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="white darken-1"
          depressed
          outlined
          text
          @click="close"
        >取消</v-btn>
        <v-btn
          v-if="isActionRequired"
          color="red darken-1"
          depressed
          outlined
          text
          @click="reject"
        >退回</v-btn>
        <v-btn
          v-if="isActionRequired"
          color="primary darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="pass"
        >通過</v-btn>
        <v-btn
          v-if="isReportable"
          color="primary darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="report"
        >回報</v-btn>
        <v-btn
          v-if="isManagerReportable"
          color="primary darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="passSelf"
        >送審</v-btn>
        <!-- 主管通過日誌，員工回報 -->
        <v-btn
          v-if="isCheckable"
          color="red darken-1"
          depressed
          outlined
          text
          @click="reject"
        >回報</v-btn>
        <!-- 主管通過日誌，員工確認 -->
        <v-btn
          v-if="isCheckable"
          color="primary darken-1"
          depressed
          outlined
          text
          :disabled="!isFormValid"
          @click="checkOK"
        >確認</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular
        indeterminate
        color="white"
      ></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
import TodoItemAutoComplete from "@/data/todo-item/TodoItemAutoComplete.js";
import TaskWorkingItemTable from "../project-dialog-task-working-item-table.vue";
import AppDataSetting from '@/data/app-data-setting.js'
import redirectMixin from "@/ui/mixin-redirect.vue";
export default {
  name: 'task-working-item-detail-dialog',
  mixins: [filterMixin, redirectMixin],
  components: { TaskWorkingItemTable },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    id: {
      type: Number,
      required: true,
      default: -1
    },
    isViewProjectButtonShown: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
    isLoading: true,
    isFormValid: false,
    form: {},
    defaultForm: {
      Name: ""
    },
    workStatusOptions: [
      { ID: "準時完成" },
      { ID: "個人問題" },
      { ID: "客戶要求" },
      { ID: "部門因素" },
      { ID: "其他" }
    ],
    // 2023/01/07 發現效能不好
    totalAssignedBudgetsOfThisProject: null,
    isShowTotalAssignedBudgetsOfThisProject: false,
    totalReviewedBudgetsOfThisProject: null,
    isShowTotalReviewedBudgetsOfThisProject: false,
    budgetConsumptionTips: null,
    isShowBudgetConsumptionTips: false
  }),
  computed: {
    formTitle() {
      return "工作日誌";
    },
    statusColor() {
      if (this.form.Status == "主管退回" || this.form.Status == "獎金退回")
        return "red";
      if (
        this.form.Status == "審核預排中" ||
        this.form.Status == "主管確認中" ||
        this.form.Status == "獎金簽核中"
      )
        return "green";
      if (this.form.Status == "獎金發放中") return "secondary";
      if (this.form.Status == "已完成") return "primary";
      return "";
    },
    editingIdx() {
      return this.$store.state.taskWorkingItem.list.findIndex(
        o => o.ID == this.id
      );
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    },
    task() {
      return AppDataSetting.getTaskWorkingItemTask(this, this.form)
    },
    projectDepartmentBudget() {
      if (!this.isShowDialog) return {} // 避免此物件建立後，又被關閉。這時候又發生資料變動，重新計算computed...
      return (
        this.projectDepartmentBudgets.find(
          o => o.ID == this.task.ProjectDepartmentBudgetID
        ) || {}
      );
    },
    taskDepartment() {
      if (!this.isShowDialog) return {} // 避免此物件建立後，又被關閉。這時候又發生資料變動，重新計算computed...
      const findTaskWorkingItemDepartmentID = o =>
        AppDataSetting.getTaskWorkingItemTask(this, o).DepartmentID;
      let departmentID = findTaskWorkingItemDepartmentID(this.form)
      return this.$store.getters.departments.find(o=>o.ID===departmentID) || {}
    },
    project() {
      if (!this.isShowDialog) return {} // 避免此物件建立後，又被關閉。這時候又發生資料變動，重新計算computed...
      return this.projectsMap[this.task.ProjectID] || {};
    },
    userOptions() {
      if (!this.isShowDialog) return {} // 避免此物件建立後，又被關閉。這時候又發生資料變動，重新計算computed...
      return this.users.map(o => ({ ID: o.ID, Name: o.Profile.Name }));
    },
    formattedDate() {
      return this.form.Date ? moment(this.form.Date).format("YYYY-MM-DD") : "";
    },
    // isCheckable: 主管通過日誌，員工確認
    isCheckable() {
      return (
        this.myLevel == 1 &&
        this.form.UserID == this.me.ID &&
        (this.form.Status == "員工確認中")
      );
    },
    isReportable() {
      return (
        this.myLevel == 1 &&
        this.form.UserID == this.me.ID &&
        (this.form.Status == "" || this.form.Status == "主管退回" || this.form.Status == "主管確認中")
      );
    },
    isManagerReportable () {
      return (
        this.myLevel == 10 && 
        this.form.UserID == this.me.ID &&
        (this.form.Status == "" || this.form.Status == "獎金退回")
      );
    },
    isDepartmentManagerReviewable() {
      if (!this.isShowDialog) return false // 避免此物件建立後，又被關閉。這時候又發生資料變動，重新計算computed...
      return (
        this.myLevel == 10 &&
        (this.form.Status == "主管確認中" || this.form.Status == "獎金退回" || this.form.Status == "主管重新確認")/* &&
        AppDataSetting.findUserDepartmentIDByID(this, this.form.UserID) == this.$store.getters.myDepartment.ID*/
      );
    },
    isDepartmentManagerVerifiable() {
      return this.myLevel == 10 && this.form.Status == "審核預排中";
    },
    isManagerReviewable() {
      return this.myLevel > 100 && this.form.Status == "獎金簽核中";
    },
    isActionRequired() {
      return (
        this.isDepartmentManagerReviewable ||
        this.isDepartmentManagerVerifiable ||
        this.isManagerReviewable
      );
    },
    isBonusOverBudget() {
      if (!this.isShowDialog) return false // 避免此物件建立後，又被關閉。這時候又發生資料變動，重新計算computed...
      let taskID = this.task.ID;
      let task = this.task;
      let taskWorkingItems = (this.taskWorkingItemsMapOfTask[taskID] || []).filter(o => o.ID != this.form.ID)
      let usedBudget = taskWorkingItems.reduce(
        (sum, item) => sum + (item.Bonus || item.Budget),
        0
      );
      return parseInt(usedBudget) + parseInt(this.form.Bonus) > task.Amount;
    },
    shouldShowBudgetUseStatus () {
      return this.myLevel >= 10
    },
    shouldShowProjectWorkingDetail () {
      return this.myLevel >= 1000
    },
    isWorkStatusVisible () {
      return true
    },
    isWorkReportVisible () {
      return true
    },
    isWorkActualHoursVisible () {
      return true
    },
    isMoneyVisible () {
      return this.myLevel >= 10 || this.form.UserID == this.me.ID
    },
    ...mapGetters([
      "me",
      "myLevel",
      "projects",
      "projectsMap",
      "tasks",
      "activeTaskList",
      "users",
      "projectDepartmentBudgets",
      "taskWorkingItems",
      "taskWorkingItemsMapOfTask"
    ])
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    reject() {
      var reason = prompt("請輸入退回原因");
      if (!reason) return alert("請輸入退回原因");
      let newStatus;
      let rejectReasonKey;
      if (this.myLevel >= 1000) { // 經理退回日誌
        rejectReasonKey = "BonusRejectedReason";
        newStatus = "獎金退回";
      } else if (this.myLevel == 10 && this.form.Status == "審核預排中") { // 主管退回預排
        rejectReasonKey = "WorkRejectedReason";
        newStatus = "主管退回";
      } else if (this.myLevel == 10 && this.form.Status == "主管確認中") { // 主管退回日誌回報
        rejectReasonKey = "ReportRejectedReason";
        newStatus = "主管退回";
      } else if (this.myLevel == 10 && this.form.Status == "主管重新確認") { // 主管退回日誌回報
        rejectReasonKey = "ReportRejectedReason";
        newStatus = "主管退回";
      } else if (this.myLevel == 10 && this.form.Status == "獎金退回") {
        rejectReasonKey = "ReportRejectedReason";
        newStatus = "被拒絕";
      } else if (this.myLevel == 1 && this.form.Status == "員工確認中") {
        rejectReasonKey = "CheckBonusRejectedReason";
        newStatus = "主管重新確認";
      } else {
        return window.alert('程式錯誤#twidd01')
      }

      let payload = {
        ID: this.form.ID
      };
      payload[rejectReasonKey] = reason;

      this.isLoading = true;

      let api;

      if (this.myLevel >= 1000) {
        api = this.$services.taskWorkingItem.rejectBonus(this, payload);
      } else if (this.myLevel == 10 && this.form.Status == "審核預排中") {
        api = this.$services.taskWorkingItem.rejectArrange(this, payload);
      } else if (this.myLevel == 10 && this.form.Status == "主管確認中") {
        api = this.$services.taskWorkingItem.rejectReport(this, payload);
      } else if (this.myLevel == 10 && this.form.Status == "獎金退回") {
        api = this.$services.taskWorkingItem.rejectReport(this, payload);
      } else if (this.myLevel == 10 && this.form.Status == "主管重新確認") {
        api = this.$services.taskWorkingItem.rejectReport(this, payload);
      } else if (this.myLevel == 1 && this.form.Status == "員工確認中") {
        api = this.$services.taskWorkingItem.rejectCheckBonus(this, payload);
      } else {
        return window.alert('程式錯誤#twidd02')
      }
      api
        .then(res => {
          this.$set(
            this.$store.state.taskWorkingItem.list[this.editingIdx],
            "Status",
            newStatus
          );
          this.$set(
            this.$store.state.taskWorkingItem.list[this.editingIdx],
            rejectReasonKey,
            reason
          );
          this.$store.state.taskWorkingItem.isReloaded = true;
          TodoItemAutoComplete.notifyActionDetected(this, 'taskWorkingItem', this.form.ID)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    passSelf() {
      this.isLoading = true;
      let newStatus = "獎金發放中";
      let payload = { 
        ID: this.form.ID, 
        Bonus: parseInt(this.form.Bonus),
        Report: this.form.Report,
        WorkStatus: this.form.WorkStatus,
        Report: this.form.Report,
        ActualHours: parseInt(this.form.ActualHours),
        ActualMinutes: parseInt(this.form.ActualMinutes)
      };
      this.$services.taskWorkingItem.submitSelf(this, payload).then(res => {
        this.$set(
          this.$store.state.taskWorkingItem.list,
          this.editingIdx,
          Object.assign(JSON.parse(JSON.stringify(this.$store.state.taskWorkingItem.list[this.editingIdx])), 
            Object.assign(payload, {'Status': newStatus}))
        );
        this.$store.state.taskWorkingItem.isReloaded = true;
        this.close();
      })
      .finally(() => {
        this.isLoading = false;
      });
    },
    pass() {
      this.isLoading = true;

      let promise;
      let newStatus;
      let payload;

      let waitingSignBonus = this.myLevel >= 1000;
      let waitingVerifyPreArrangeWork =
        this.myLevel == 10 && this.form.Status == "審核預排中";
      let waitingSubmitWorkBonus =
        this.myLevel == 10 &&
        (this.form.Status == "主管確認中" || this.form.Status == "獎金退回" || this.form.Status == "主管重新確認");

      if (waitingSignBonus) {
        newStatus = "獎金發放中";
      } else if (waitingVerifyPreArrangeWork) {
        newStatus = "";
        payload = { ID: this.form.ID, Budget: parseInt(this.form.Budget) };
        if (payload.Budget > 1000000000) {
          return alert("獎金不可大於10億");
        }
      } else if (waitingSubmitWorkBonus) {
        newStatus = "員工確認中";
        payload = { ID: this.form.ID, Bonus: parseInt(this.form.Bonus), };
        if (payload.Bonus > 1000000000) {
          return alert("獎金不可大於10億");
        }
      } else {
        return alert("錯誤：狀態錯誤");
      }

      if (waitingSignBonus) {
        promise = this.$services.taskWorkingItem.sign(this, this.form.ID);
      } else if (waitingVerifyPreArrangeWork) {
        promise = this.$services.taskWorkingItem.verify(this, payload);
      } else if (waitingSubmitWorkBonus) {
        promise = this.$services.taskWorkingItem.submit(this, payload);
      } else {
        return alert("錯誤：狀態錯誤");
      }
      let actionType = waitingSignBonus ? '簽核獎金' : null

      promise
        .then(res => {
          this.$set(
            this.$store.state.taskWorkingItem.list[this.editingIdx],
            "Status",
            newStatus
          );
          if (newStatus == "獎金簽核中") {
            this.$set(
              this.$store.state.taskWorkingItem.list[this.editingIdx],
              "Bonus",
              payload.Bonus
            );
          } else if (newStatus == "") {
            this.$set(
              this.$store.state.taskWorkingItem.list[this.editingIdx],
              "Budget",
              payload.Budget
            );
          }
          this.$store.state.taskWorkingItem.isReloaded = true;
          TodoItemAutoComplete.notifyActionDetected(this, 'taskWorkingItem', this.form.ID, actionType)
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // checkOK: 員工確認日誌
    checkOK() {
      var newStatus = "獎金發放中";
      this.isLoading = true;
      this.$services.taskWorkingItem
        .checkOK(this, this.form.ID)
        .then(res => {
          // this.$set(
          //   this.$store.state.taskWorkingItem.list,
          //   this.editingIdx,
          //   res.data.result
          // );
          this.$set(
            this.$store.state.taskWorkingItem.list[this.editingIdx],
            "Status",
            newStatus
          );
          this.$store.state.taskWorkingItem.isReloaded = true;
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    // report: 員工回報日誌
    report() {
      if (!this.$refs.form.validate()) return;
      this.form.ActualHours = parseInt(this.form.ActualHours) || 0;
      this.form.ActualMinutes = parseInt(this.form.ActualMinutes) || 0

      if (this.editingIdx < 0) {
        alert("發生異常：無法找到編輯物件");
        return;
      }

      if (!this.form.ActualHours && !this.form.ActualMinutes) {
        if (!window.confirm('處理時數為0，未填寫，確認送出回報嗎?')) return
      }

      this.isLoading = true;
      this.$services.taskWorkingItem
        .report(this, this.form)
        .then(res => {
          this.$set(
            this.$store.state.taskWorkingItem.list,
            this.editingIdx,
            res.data.result
          );
          this.$store.state.taskWorkingItem.isReloaded = true;
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      if (!this.value) return;
      if (this.id < 0 || this.editingIdx < 0) {
        alert("發生異常：無法找到編輯物件");
        return this.close();
      }
      this.totalAssignedBudgetsOfThisProject = null
      this.totalReviewedBudgetsOfThisProject = null
      this.budgetConsumptionTips = null
      if (this.$refs.cardContent) {
        this.$nextTick(() => this.$refs.cardContent.scrollTo(0, 0));
      }
      this.form = JSON.parse(
        JSON.stringify(this.$store.state.taskWorkingItem.list[this.editingIdx])
      );
      // if (this.isDepartmentManagerReviewable)
      //   this.form.Bonus = this.form.Budget;
    },
    // 2023/01/07 效能差
    calculateTotalAssignedBudgetsOfThisProject () {
      if (!this.isShowDialog) return 0 // 避免此物件建立後，又被關閉。這時候又發生資料變動，重新計算computed...

      let taskWorkingItems = this.taskWorkingItems.filter(
        o => {
          let task = AppDataSetting.attachTaskWorkingItemTask(this, o)
          return task.ProjectStage == this.task.ProjectStage &&  task.ProjectID == this.task.ProjectID && task.DepartmentID == this.task.DepartmentID
        }
      );
      let usedBudget = taskWorkingItems.reduce(
        (sum, item) => sum + (item.Budget),
        0
      );
      return usedBudget
    },
    calculateTotalReviewedBudgetsOfThisProject () {
      if (!this.isShowDialog) return 0 // 避免此物件建立後，又被關閉。這時候又發生資料變動，重新計算computed...

      // 這一段filter要7秒 - attachTaskWorkingItemTask
      // 這一段filter要7秒 - getTaskWorkingItemTask
      let taskWorkingItems = this.taskWorkingItems.filter(
        o => {
          let task = AppDataSetting.getTaskWorkingItemTask(this, o)
          return task.ProjectStage == this.task.ProjectStage && (o.Status == '獎金發放中' || o.Status == '已完成') && task.ProjectID == this.task.ProjectID && task.DepartmentID == this.task.DepartmentID
        }
      );
      let usedBudget = taskWorkingItems.reduce(
        (sum, item) => sum + (item.Bonus),
        0
      );
      return usedBudget
    },
    calculateBudgetConsumptionTips() {
      if (!this.isShowDialog) return '' // 避免此物件建立後，又被關閉。這時候又發生資料變動，重新計算computed...
      if (this.myLevel < 10 && this.form.UserID != this.me.ID) return '';
      let taskWorkingItems = this.taskWorkingItems.filter(
        o => o.TaskID == this.task.ID /* && o.ID != this.form.ID*/
      );
      let usedBudget = taskWorkingItems.reduce(
        (sum, item) => sum + (item.Bonus || item.Budget),
        0
      );
      var tips = "";
      // 1. 專案部門預算
      //tips += `部門專案預算(${this.task.ProjectStage}): ${this.projectDepartmentBudget.Budget}`;
      // 2. 任務預算
      tips += `任務預算: ${this.task.Amount}, 此任務已編列 ${usedBudget}`;
      return tips;
    },
    viewTotalAssignedBudgetsOfThisProject () {
      this.totalAssignedBudgetsOfThisProject = this.calculateTotalAssignedBudgetsOfThisProject()
    },
    viewTotalReviewedBudgetsOfThisProject () {
      this.totalReviewedBudgetsOfThisProject = this.calculateTotalReviewedBudgetsOfThisProject()
    },
    viewBudgetConsumptionTips () {
      this.budgetConsumptionTips = this.calculateBudgetConsumptionTips()
    },
    autoCalculate () {
      this.viewTotalAssignedBudgetsOfThisProject()
      this.viewTotalReviewedBudgetsOfThisProject()
      this.viewBudgetConsumptionTips()
    },
    onActualMinutesChanged () {
      var n = parseInt(this.form.ActualMinutes)
      if (!n || isNaN(n)) return;
      if (n > 59) {
        this.form.ActualMinutes = ''
        this.$nextTick(()=>{
          this.form.ActualMinutes = 59
        })
      }
    }
  },
  created() {
    this.resetForm();
    // 2021/03/18 不要每次開視窗都要讀取，這樣會很慢
    if (!this.$store.state.taskWorkingItem.isFetched) {
      this.isLoading = true;
      this.$services.taskWorkingItem.prepareData(this).finally(() => {
        this.isLoading = false;
      });
    } else {
      this.isLoading = false
    }
  },
  mounted () {
    this.autoCalculate()
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    },
    id() {
      this.resetForm();
      this.$nextTick(()=>{
        this.autoCalculate()
      })
    }
  }
};
</script>